export default "__VITE_ASSET__7bxPNfmD__"